
<div *ngIf="isVisible && !isMobile()" class="col-lg-12 col-md-12 col-sm-12" id="cookies-banner">
    <p id="cookies-text">We use cookies and other tracking technologies to improve your browsing experience on our website, to show you personalized
        content and targeted ads, to analyze our website traffic, and to understand where our visitors are coming from. By browsing our
         website, you consent to our use of cookies and other tracking technologies. </p>
    <!--<a id="link" routerLink="/privacy">Learn More</a>-->
    <div id="tablet-display">
        <button (click)="setCookiesTrue()" id="gotit-button">Accept</button>
        <button (click)="denyCookies()" id="gotit-button">Deny</button>
    </div>
</div>

<div *ngIf="isVisible && isMobile()" class="col-lg-12 col-md-12 col-sm-12" id="cookies-bannerMobile">
    <p id="cookies-textMobile">We use cookies and other tracking technologies to improve your browsing experience on our website, to show you personalized
        content and targeted ads, to analyze our website traffic, and to understand where our visitors are coming from. By browsing our
         website, you consent to our use of cookies and other tracking technologies. </p>
    <!--<a id="link" routerLink="/privacy">Learn More</a>-->
    <div id="tablet-display">
        <button (click)="setCookiesTrue()" id="gotit-buttonMobile">Accept</button>
        <button (click)="denyCookies()" id="gotit-buttonMobile">Deny</button>
    </div>
</div>
